import { colors } from '@core/assistant/colors';

export const useStyles = () => {
  return {
    box: {
      width: 207,
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      background: colors.black_99,
      padding: 2,
      borderRadius: 6,
      border: `1px solid ${colors.white_90}`,
      backdropFilter: 'blur(60px)',
    },
    button: {
      borderRadius: 99,
      border: '1px solid ' + colors.white,
      padding: 1.5,
      fontSize: 14,
      lineHeight: 1,
      textTransform: 'none',
      color: colors.white,
    },
    debugOverlay: {
      position: 'absolute',
      marginLeft: '-450px',
      width: '400px',
      background: 'rgba(10, 10, 10, 0.8)',
      height: '260px',
      padding: '10px',
      borderRadius: 6,

      button: {
        margin: '10px',
      },
    },
    debugButton: {
      borderRadius: '10px',
      border: '1px solid ' + colors.white,
      padding: 1.5,
      fontSize: 14,
      lineHeight: 1,
      textTransform: 'none',
      color: colors.white,
    },
    debugStartFlowButton: {
      position: 'relative',
      top: '6px',
    },
    debugSelect: {
      width: '180px',
      margin: '10px 20px 10px 10px',
      '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: colors.white,
      },
      '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        borderColor: colors.white,
      },
      '& .MuiOutlinedInput-input': {
        color: colors.white,
      },
      '& .MuiSvgIcon-root': {
        color: colors.white,
      },
      '& .MuiInputLabel-root': {
        color: colors.white,
      },
      '& .MuiInputLabel-root.Mui-focused': {
        color: colors.myta,
      },
    },
    blueButton: {
      background: colors.myta,
    },
    hideButton: {
      marginTop: 1,
      padding: 0,
      textTransform: 'none',
      fontSize: 14,
      lineHeight: 1.5,
      color: colors.white,
    },
  };
};
